/* Elevate PrintWerks: shows the mill's photo of the blank in the color picked in the designer. */
(function () {
  function show(fig, photos, color) {
    var p = photos[color] || {};
    var any = false;
    ['front', 'back'].forEach(function (side) {
      var img = fig.querySelector('[data-epw-photo-' + side + ']');
      if (!img) return;
      if (p[side]) {
        if (img.getAttribute('src') !== p[side]) img.src = p[side];
        img.alt = color + ' blank, ' + side;
        img.hidden = false;
        any = true;
      } else {
        img.removeAttribute('src');
        img.hidden = true;
      }
    });
    var name = fig.querySelector('[data-epw-photo-color]');
    if (name) name.textContent = color;
    fig.hidden = !any;
  }
  function start() {
    document.querySelectorAll('[data-epw-photo]').forEach(function (fig) {
      var photos = {};
      try { photos = JSON.parse((fig.querySelector('[data-epw-photos]') || {}).textContent || '{}'); } catch (e) { return; }
      var page = fig.closest('.epw-pdp') || document;
      var current = function () {
        var on = page.querySelector('[data-epw-color][aria-pressed="true"]') || page.querySelector('[data-epw-color]');
        if (on) show(fig, photos, on.getAttribute('data-epw-color'));
      };
      current();
      // The designer marks the chosen swatch with aria-pressed; follow it.
      var swatches = page.querySelector('[data-epw-swatches]');
      if (swatches && window.MutationObserver) {
        new MutationObserver(current).observe(swatches, { subtree: true, attributes: true, attributeFilter: ['aria-pressed'] });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
